import axios from "axios";
import { jwtDecode } from "jwt-decode";

const Global = {
  backend: "https://techoney.mmd-observatory.com",
  frontend: "/",  // web app basename
  stripePublicKey: "pk_test_51T1NBpDTw7tJXuuJOxyCKOcxBXVkK8IcowucY9OC32KekZZKzfy6ddidMHAKSczsVW2HTozsvuabFeSYvHGHBrz400bIBE8SAo",
  stripePaymentsLink: "https://dashboard.stripe.com/test/payments/",
  stripeTransfersLink: "https://dashboard.stripe.com/test/transfers/",
  basecolor: "#13c6dd",
  facebookLink: "https://facebook.com",
  instagramLink: "https://instagram.com",
  youtubeLink: "https://youtube.com",
  linkedinLink: "https://linkedin.com"
}
export default Global;






export function formatDate(dateString) {
  const date = new Date(dateString)

  // Extract parts of the date
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear();

  // Get hours and format them to 12-hour format
  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12

  return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`
}





export function copyToClipBoard(text) {
  navigator.clipboard.writeText(text).catch(() => { })
}


export async function getIsStripeSupportedCurrency(currency = "EUR") {
  const STRIPE_SUPPORTED_CURRENCY = Global.backend + "/index.php/api/commande/getIsStripeSupportedCurrency";

  const response = await axios.post(STRIPE_SUPPORTED_CURRENCY, { currency })

  return response.data
}


export async function getProcessingFee(amount, currency) {
  const PROCESSING_FEE_URL = Global.backend + "/index.php/api/commande/getProcessingFee";


  const response = await axios.post(PROCESSING_FEE_URL, {
    amount: amount,
    currency: currency
  })

  return response.data;
}


export async function extendJWT() {
  const EXTEND_URL = Global.backend + "/index.php/api/extend-jwt";

  const currentToken = localStorage.getItem("token")



  try {
    const response = await axios.post(EXTEND_URL, {}, {
      headers: {
        'Authorization': `Bearer ${currentToken}`,
      },
    });

    if (response.data.new_token) {
      localStorage.setItem("token", response.data.new_token);
      return response.data.new_token;
    }
  } catch (error) {

  }
}


// Utility function to check if the token is near expiration
export const isTokenNearExpiration = () => {
  const token = localStorage.getItem("token")
  if (!token) {
    return false
  }
  const decodedToken = jwtDecode(token)
  const expirationTime = decodedToken.exp * 1000
  const currentTime = Date.now()

  // minutes
  const minRefreshTime = 15
  return expirationTime - currentTime < minRefreshTime * 60 * 1000;
}


export function isStripePaymentConnected() {
  return localStorage.getItem("stripeAccountId") && localStorage.getItem("stripeAccountId") != "null"
}

export function isAuthenticated() {
  const token = localStorage.getItem("token")

  if (!token) return false

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000


    if (decoded.exp < currentTime) {
      localStorage.removeItem("token")
      return false
    }

    return true
  } catch (error) {
    return false
  }
}


export function getCachedData(key, userKey = true, userId = localStorage.getItem("id")) {
  let cachedData = JSON.parse(localStorage.getItem("cache"))


  if (!cachedData || (userKey && !cachedData[userId])) {
    return null
  }

  if (userKey) {
    return cachedData[userId][key] || null
  } else {
    return cachedData[key] || null
  }
}
export function setCachedData(key, value, userKey = true, userId = localStorage.getItem("id")) {
  let cachedData = JSON.parse(localStorage.getItem("cache"))

  if (!cachedData) {
    cachedData = {}
  }
  if (userKey && !cachedData[userId]) {
    cachedData[userId] = {}
  }

  if (userKey) {
    cachedData[userId][key] = value
  } else {
    cachedData[key] = value
  }

  localStorage.setItem("cache", JSON.stringify(cachedData))
}


// cached Data
export function getUnReadedChats(lastMessagesResponse) {
  if (!lastMessagesResponse) {
    return getCachedData("unReadedChats") || []
  }

  let unreadedChatUserIds = []


  lastMessagesResponse.data.messages.forEach(msg => {
    if (msg.receiver_id == localStorage.getItem("id") && msg.sender_id != localStorage.getItem("id")) {
      // exclude myself from new messages since i read my own when i send them
      if (!isReadedChat(msg.sender_id, msg.id)) {
        unreadedChatUserIds.push(Number(msg.sender_id))
      }
    }
  })

  // save unreaded chats count to localstorage
  saveUnreadedChats(unreadedChatUserIds)

  return unreadedChatUserIds
}
export function saveUnreadedChats(userIds) {
  setCachedData("unReadedChats", userIds)
}
function getReadedChats() {
  return getCachedData("readedChats") || {
    // user id:last chat message id
  }
}
function isReadedChat(userId, messageId) {
  const readedChats = getReadedChats()
  return readedChats[userId] == messageId ? true : false
}
export function saveReadedChat(userId, messageId) {
  if (isReadedChat(userId, messageId)) {
    return false
  }
  // used to save last message id of a selected chat by user id
  const readedChats = getReadedChats()
  readedChats[userId] = messageId

  setCachedData("readedChats", readedChats)
  return true
}




export function getUnreadedSales() {
  return Number(getCachedData("unreadedSales")) || 0
}
export function saveUnreadedSales(count) {
  setCachedData("unreadedSales", count)
}
export function isReadedSale(id) {
  return getReadedSales().map(val => Number(val)).includes(Number(id)) ? true : false
}
function getReadedSales() {
  return getCachedData("readedSales") || []
}
export function saveReadedSale(id) {
  if (isReadedSale(id)) {
    return false
  }
  const readedSales = getReadedSales()
  readedSales.push(id)

  setCachedData("readedSales", readedSales)
  return true
}


export function getUnreadedProducts() {
  return Number(getCachedData("unreadedProducts")) || 0
}
export function saveUnreadedProducts(count) {
  setCachedData("unreadedProducts", count)
}
export function isReadedProduct(id) {
  return getReadedProducts().map(val => Number(val)).includes(Number(id)) ? true : false
}
function getReadedProducts() {
  return getCachedData("readedProducts") || []
}
export function saveReadedProduct(id) {
  if (isReadedProduct(id)) {
    return false
  }
  const readedProducts = getReadedProducts()
  readedProducts.push(id)

  setCachedData("readedProducts", readedProducts)
  return true
}




export function getUnreadedOrders() {
  return Number(getCachedData("unreadedOrders")) || 0
}
export function saveUnreadedOrders(count) {
  setCachedData("unreadedOrders", count)
}
export function isReadedOrder(id) {
  return getReadedOrders().map(val => Number(val)).includes(Number(id)) ? true : false
}
function getReadedOrders() {
  return getCachedData("readedOrders") || []
}
export function saveReadedOrder(id) {
  if (isReadedOrder(id)) {
    return false
  }
  const readedOrders = getReadedOrders()
  readedOrders.push(id)

  setCachedData("readedOrders", readedOrders)
  return true
}



export function getUnreadedAds() {
  return Number(getCachedData("unreadedAds")) || 0
}
export function saveUnreadedAds(count) {
  setCachedData("unreadedAds", count)
}
export function isReadedAd(id) {
  return getReadedAds().map(val => Number(val)).includes(Number(id)) ? true : false
}
function getReadedAds() {
  return getCachedData("readedAds") || []
}
export function saveReadedAd(id) {
  if (isReadedAd(id)) {
    return false
  }
  const readedAds = getReadedAds()
  readedAds.push(id)

  setCachedData("readedAds", readedAds)
  return true
}







export function formatLongNumber(number) {
  return new Intl.NumberFormat('en-US').format(number);
}








export function isBusinessAccountType(accountType = localStorage.getItem("compte")) {
  return Number(accountType) == 1
}

export const isValidAccount = () => {
  return JSON.parse(localStorage.getItem("valid"))
}

export const isBlockedACcount = () => {
  return JSON.parse(localStorage.getItem("blocked"))
}

export const isVerifiedAccount = () => {
  return JSON.parse(localStorage.getItem("verified"))
}

export function isAdminAccount(roles = localStorage.getItem("roles")) {
  return roles ? roles.includes("ROLE_ADMIN") : false
}

export function onUserLogout() {
  const cachedData = JSON.parse(localStorage.getItem("cache"))
  localStorage.clear()
  localStorage.setItem("cache", JSON.stringify(cachedData))
}


export function fetchProducts(response, promotionOnly, bothVisibleInvisible = false) {
  let filteredProducts = [];


  response.data
    .slice()
    .map((item) => {
      if (bothVisibleInvisible) {
        if (promotionOnly ? item.discount : true) {
          filteredProducts.push(item);
        }
      } else {
        if (item.visibilite == true && (promotionOnly ? item.discount : true)) {
          filteredProducts.push(item);
        }
      }
    })




  return filteredProducts
}

export function getProductsPriceRange(productList, currency, getCurrencyPrice) {
  let convertedPriceList = productList.map((product) => {
    return getCurrencyPrice(product.prix, product.currency, currency)
  })

  let min = convertedPriceList[0]
  let max = convertedPriceList[0]

  for (let index = 0; index < convertedPriceList.length - 1; index++) {
    let nextPrice = convertedPriceList[index + 1]

    if (max < nextPrice) {
      max = nextPrice
    }
    if (min > nextPrice) {
      min = nextPrice
    }
  }

  return [min, max]
}





export function fetchAds(response) {
  let ads = response.data
  let max = 0;
  let min = 0;



  max = ads[0].prix;
  min = ads[0].prix;


  for (let index = 0; index < ads.length - 1; index++) {
    if (max < ads[index + 1].prix) {
      max = ads[index + 1].prix;
    }
    if (min > ads[index + 1].prix) {
      min = ads[index + 1].prix;
    }
  }



  return {
    adsList: ads,
    minPrice: min,
    maxPrice: max
  }
}
